import { LitElement, html, css } from 'lit';


class WebSVG extends LitElement {
  static get properties() {
    return {
      src: { type: String }
    }
  }

  static get styles() {
    return css`
      :host {
        position: relative;
        display: inline-block;
        width: auto;
        height: auto;
      }
    `;
  }

  constructor() {
    super();
    this.src = '';
  }

  firstUpdated() {
    super.firstUpdated();
    if (this.src) {
      const OPTS = {
        mode: "same-origin",
        credentials: "same-origin",
      };
      fetch(this.src, OPTS)
        .then(response => {
          if (response.status == 200) return response.text();
          return '';
        })
        .then((text) => {
          this.innerHTML = text;
        });
    }
  }

  render() {
    return html`<slot></slot>`;
  }
}

customElements.define('web-svg', WebSVG);
